module.exports = __webpack_public_path__ + "img/no-open.224d2c9d.png";